module.exports = __webpack_public_path__ + "hyperion-v2-static/fonts/TruenoUltBlk.87bdac0a.otf";